// index.js
// Component for Order View

// Imports
import React from 'react';
import { Flex } from 'reflexbox';
import { withRouter } from 'react-router-dom';
import { MenuItem, NonIdealState, Button, Checkbox } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import PropTypes from 'prop-types';
import ProductList from './ProductList';

// Component Class
// Shows Order View
class OrderView extends React.Component {
  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      filterEmptyProducts: true,
    }
  }

  // Returns the name for the client with the given id
  getClientName = (id) => {
    return this.props.clients.byId[id].name;
  };

  // Selects the client with the given id
  clientSelected = (id) => {
    this.props.history.push('/order/'+id);
  };

  // Method for evaluating typeahead queries
  clientPredicate = (query, id) => {
    var name = this.getClientName(id);
    return name.toLowerCase().includes(query.toLowerCase());
  }

  // Method for rendering clients on the selection list
  clientItemRenderer = (id, options) => {
    if (!options.modifiers.matchesPredicate) {
      return null;
    }
    return (
      <MenuItem
        active={options.modifiers.active}
        onClick={options.handleClick}
        key={id}
        text={this.props.clients.byId[id].name}
      />
    );
  };
  
  // Called when the checkbox for viewing only products with order is toggled
  filterEmptyChanged = (event) => {
    this.setState({
      filterEmptyProducts: event.target.checked,
    });
  }

  // Renders Component
  render() {
    var clientId = Number.parseInt(this.props.match.params.clientId, 10);
    if (!clientId && this.props.clients.ids.length > 0)
      clientId = this.props.clients.ids[0];

    var main;
    if (clientId)
      main = (
        <ProductList
          filterEmpty={this.state.filterEmptyProducts}
          order={this.props.orders.current}
          clientId={clientId}
          {...this.props}
        />);
    else
      main = (
        <div>
          <br />
          <NonIdealState
            visual="refresh"
            title="Nenhum Cliente Disponível"
            description="Crie um cliente para começar a editar pedidos"
          />
        </div>
      );

    var selectedClient = "Nenhum Cliente Disponível";
    if (clientId)
      selectedClient = this.props.clients.byId[clientId].name;

    return (
      <div>
        {clientId && (
          <div>
            <br />
            <Flex align='center' justify='center' column w={1}>
              <Flex align='center' justify='center' >
                <b>Cliente:&nbsp;</b>
                <Select
                  value={clientId}
                  items={this.props.clients.ids}
                  itemRenderer={this.clientItemRenderer}
                  inputValueRenderer={this.getClientName}
                  itemPredicate={this.clientPredicate}
                  onItemSelect={this.clientSelected}
                >
                  <Button text={selectedClient} rightIcon="double-caret-vertical" fill />
                </Select>
              </Flex>
              <br />
              <Flex>
                <Checkbox
                  label="Ver Somente Compras"
                  checked={this.state.filterEmptyProducts}
                  onChange={this.filterEmptyChanged}
                />
              </Flex>
            </Flex>
          </div>
        )}
        <br />
        <Flex align='center' justify='center' w={1}>
          {main}
        </Flex>
      </div>
    );
  }
}

// Required Properties
OrderView.propTypes = {
  clients: PropTypes.object.isRequired,
  orders: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  setOrderProduct: PropTypes.func.isRequired,
  setOrderAdjustment: PropTypes.func.isRequired,
}

// Exports
export default withRouter(OrderView);


// WEBPACK FOOTER //
// ./src/components/OrderView/index.js